const RANKING_ITEMS = [
  { id: 'r1', rank: 1, title: '某顶流明星恋情曝光事件全追踪', hot: '🔥 热度 96,000+', tag: '娱乐' },
  { id: 'r2', rank: 2, title: '千万粉网红直播翻车名场面合集', hot: '🔥 热度 82,000+', tag: '直播' },
  { id: 'r3', rank: 3, title: '知名企业被曝内部问题持续发酵', hot: '🔥 热度 75,000+', tag: '社会' },
  { id: 'r4', rank: 4, title: '热播综艺录制意外突发状况', hot: '🔥 热度 68,000+', tag: '综艺' },
  { id: 'r5', rank: 5, title: '国际品牌代言人删除官宣物料', hot: '🔥 热度 59,000+', tag: '品牌' },
];

const RANK_COLORS: Record<number, string> = {
  1: 'bg-accent-500',
  2: 'bg-accent-400',
  3: 'bg-accent-300',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          本周网络热门事件热度排行 TOP 5
        </p>
        <div className="space-y-3">
          {RANKING_ITEMS.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${
                  RANK_COLORS[item.rank] || 'bg-secondary-400'
                }`}
              >
                <span className="text-white font-heading text-base">{item.rank}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="bg-primary-100 text-primary-700 text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}